import { Box, Button, Container, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import emailVerificationImg from "../../assets/icon_eMailVerifier_new_1200x630.jpeg";

import { verifyDevEmail } from "../../features/Auth/authSlice";

const VerifyEmail = () => {
  const [param, setParam] = useState("");

  const params = useLocation();
  const [searchParams] = useSearchParams();
  const assesToken = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const params = assesToken;

  // assesToken.split(":8000");
  // const {*} = assesToken
  // console.log(params.search);
  var verificationUrl = params.search;
  // console.log(verificationUrl.split(":8000")[1]);
  var verificationUrl = verificationUrl.split(":8000")[1];

  useEffect(() => {
    setParam(verificationUrl);

    // console.log(verificationUrl);

    dispatch(verifyDevEmail(param));
  }, [param]);

  return (
    <>
      <Container maxWidth="sm">
        <Box
          p={3}
          sx={{
            display: "flex",

            flexDirection: "column",
          }}
        >
          <Paper p={2} m={2}>
            <Box sx={{}}>
              <Box
                component="img"
                sx={{ width: "100%", height: "100%" }}
                src={emailVerificationImg}
              />
            </Box>
          </Paper>
          <Box p={2} m={2}>
            <Paper>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                p={3}
              >
                <Typography>
                  You Email Account has been verified successfully !{" "}
                </Typography>
                <Button
                  onClick={() => navigate("/dev/dashboard")}
                  p={2}
                  mt={2}
                  variant="outlined"
                >
                  Take me to Dashboard
                </Button>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Container>
      !
    </>
  );
};
// epiz_32903685;
export default VerifyEmail;
